// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c625185b","977":"3cc2bbf2"}[chunkId] + ".chunk.js";
};